export default "__VITE_ASSET__CgCflcC1__"